import { useState } from 'preact/hooks';
import { haptic } from '../lib/haptics.js';

/**
 * What the room is and what it is doing.
 *
 * Share is a first-class control rather than a menu item: a show spreads by
 * someone sending the link mid-set, and burying that behind a menu is how a
 * social product fails to be social.
 */
export function RoomHeader({
  title,
  live,
  recording,
  roomId,
}: {
  title: string;
  live: boolean;
  recording: boolean;
  roomId: string;
}) {
  const [copied, setCopied] = useState(false);

  const share = async () => {
    haptic('press');
    const url = `${window.location.origin}/r/${roomId}`;
    // Native sheet where it exists — on a phone that is the whole point, since
    // it reaches WhatsApp directly rather than via a clipboard round trip.
    if (navigator.share) {
      try {
        await navigator.share({ title, text: `Listen to ${title} on Waves`, url });
        return;
      } catch {
        /* dismissed — fall through to copying */
      }
    }
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      /* clipboard needs a secure context and permission; nothing else to try */
    }
  };

  return (
    <header class="roomhead">
      <div class="roomhead__body">
        <div class="roomhead__status">
          {live ? (
            <span class="chip chip--live">
              <span class="chip__dot" />
              Live
            </span>
          ) : recording ? (
            <span class="chip chip--rec">Recording</span>
          ) : (
            <span class="chip">Room</span>
          )}
        </div>
        <h1 class="roomhead__title" title={title}>
          {title}
        </h1>
      </div>
      <button class="roomhead__share" onClick={share} aria-label="Share this room">
        {copied ? 'Copied' : 'Share'}
      </button>
    </header>
  );
}
